import { FC, useEffect } from "react";

export const NoTranslateInjector: FC = () => {
    useEffect(() => {
        const htmlTag = document.querySelector("html");

        if (!htmlTag) {
            return;
        }

        htmlTag.setAttribute("translate", "no");
    }, []);

    return null;
};
